import { useNavigate } from 'react-router-dom';

export default function CheckoutSuccess() {
  const navigate = useNavigate();

  return (
    <div className="max-w-md mx-auto py-12 px-4 text-center">
      <div className="rounded-2xl bg-green-100 dark:bg-green-900/30 border border-green-200 dark:border-green-800 p-8">
        <h1 className="text-2xl font-semibold text-green-800 dark:text-green-200 mb-4">
          Payment complete
        </h1>
        <p className="text-lg text-green-700 dark:text-green-300">
          Thank you for your purchase.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="mt-6 px-6 py-3 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 active:bg-indigo-800 transition-colors"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}
